import { BodyText, DetailText, Flex } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import { multViaPence } from '@features/Cashback/Calculator/utils/createCalcOutput';
import { formatNumber } from '@utils/format';

import './styles.scss';

const multMap = {
  monthly: {
    multiplier: 1,
    label: 'Monthly',
  },
  yearly: {
    multiplier: 12,
    label: 'Yearly',
  },
  twoYears: {
    multiplier: 24,
    label: '2 years',
  },
};

enum MultTime {
  Monthly = 'monthly',
  Yearly = 'yearly',
  TwoYears = 'twoYears',
}

interface OverTimeBarProps {
  total: number;
  time: MultTime;
}
const OverTimeBar = ({ total, time }: OverTimeBarProps) => {
  const { label, multiplier } = multMap[time];
  const calculated = multViaPence(total, multiplier);
  return (
    <div
      className={clsx('earnTime__Item', {
        ['earnTime__Item--yearly']: (time as MultTime) === MultTime.Yearly,
        ['earnTime__Item--twoYears']: (time as MultTime) === MultTime.TwoYears,
      })}
    >
      <DetailText
        size={{ mobile: 'lg', desktop: '2xl' }}
        className="earnTime__ItemValue"
      >
        £
        {formatNumber(calculated, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </DetailText>
      <div className="earnTime__ItemBar" />
      <BodyText size="md" weight="semibold">
        {label}
      </BodyText>
    </div>
  );
};

interface OverTimeProps {
  earnings: number;
}

const OverTime = ({ earnings }: OverTimeProps) => {
  return (
    <Flex
      className="earnTime__Container"
      spacing="sm"
      alignItems="end"
      justifyContent="between"
    >
      <OverTimeBar total={earnings} time={MultTime.Monthly} />
      <OverTimeBar total={earnings} time={MultTime.Yearly} />
      <OverTimeBar total={earnings} time={MultTime.TwoYears} />
    </Flex>
  );
};

export { OverTime };
